import { Component, ElementRef, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { GameService } from '../../../../shared/services/game/game.service';

@Component({
    selector: 'app-game-disclaimer',
    templateUrl: './game-disclaimer.component.html'
})
export class GameDisclaimerComponent implements OnInit {

    public gameId: string = '';
    public showDisclaimer: boolean = false;
    public disclaimer: string = '';

    constructor(public elementRef: ElementRef, private route: ActivatedRoute, public gameService: GameService) {
    }

    ngOnInit(): void {
        this.route.paramMap.subscribe(params => {
            this.gameId = params.get('id');
        });
        this.gameService.refreshGameDetailsObservable.subscribe(details => {
            // Game is loaded
            if (details.codes == this.gameId) {
                if (details.disclaimer && details.disclaimer != '') {
                    this.showDisclaimer = true;
                    this.disclaimer = details.disclaimer;
                }
            }


        });
    }

}
